import { ProjectSelectionListComponent } from "./selection-list";

export * from "./selection-list";

export const ProjectMolecules = [ProjectSelectionListComponent];
